import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import GlobalContext from "../../../context/GlobalContext";
import { userService } from "../../../services/CommonServices";
import ReactPaginate from "react-paginate";
import Loader from "../../Loader/Loader";

const WeeklyChargesList = () => {
  let navigate = useNavigate();
  const globalData = useContext(GlobalContext);

  const [res, setRes] = useState([]);
  const [providers, setProviders] = useState([]);
  const [selectedProvider, setSelectedProvider] = useState("");

  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const itemsPerPage = 10;

  // Fetch provider list
  const fetchProviders = () => {
    const headers = { Authorization: globalData.token };
    userService.get_providers_ids_and_names_api(headers)
      .then((response) => {
        if (response.status === 200) {
          setProviders(response.data.data || []);
        }
      })
      .catch((error) => {
        console.error("Error fetching providers:", error);
      });
  };

  // Fetch weekly charges
  const fetchWeeklyCharges = (page) => {
    setIsLoading(true);
    const headers = { Authorization: globalData.token };
    const query = {
      page,
      size: itemsPerPage,
      providerId: selectedProvider,
    };

    userService.weekly_charges_list_api(headers, query)
      .then((response) => {
        if (response.status === 200) {
          setRes(response.data.data || []);
          setTotalItems(response.data.total);
        }
      })
      .catch((error) => {
        console.error("Error fetching weekly charges:", error);
        if (error.response?.status === 401) {
          globalData.set_token("");
          globalData.set_org_id("");
          sessionStorage.removeItem("token");
          sessionStorage.removeItem("org_id");
          navigate("/login");
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  // Handle apply filters
  const handleApplyFilters = () => {
    setCurrentPage(0);
    fetchWeeklyCharges(0);
  };

  // Handle clear filters
  const handleClearFilters = () => {
    setSelectedProvider("");
    setCurrentPage(0);
    fetchWeeklyCharges(0);
  };

  // Handle pagination
  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
    fetchWeeklyCharges(event.selected);
  };

  useEffect(() => {
    fetchProviders();
    fetchWeeklyCharges(0);
  }, []);

  return (
    <div className="content_area">
      {isLoading && <Loader />}
      <div className="tables_area">
        <div className="title-box">
          <h2 className="pull-left">Weekly Charges List</h2>
          <div className="clear"></div>
        </div>

        <div className="filter-box">
          <div className="filters">
            <label>Provider</label>
            <select
              value={selectedProvider}
              onChange={(event) => setSelectedProvider(event.target.value)}
            >
              <option value="">All Providers</option>
              {providers.map((provider) => (
                <option key={provider.id} value={provider.id}>
                  {provider.name}
                </option>
              ))}
            </select>
          </div>
          <button className="btn btn-primary" onClick={handleApplyFilters}>
            Apply Filters
          </button>
          <button className="btn btn-secondary" onClick={handleClearFilters}>
            Clear Filters
          </button>
        </div>

        <div className="white_box">
          <div className="table-responsive">
            <table width="100%" cellSpacing="0" cellPadding="0">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Provider</th>
                  <th>Start Time</th>
                  <th>End Time</th>
                  <th>Total Service Charges</th>
                  <th>Service Charges Paid</th>
                  <th>Extra Amount Paid</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {res.map((item) => (
                  <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{item.provider.firstName + " " + item.provider.lastName}</td>
                    <td>{item.startTime}</td>
                    <td>{item.endTime}</td>
                    <td>{item.totalServiceCharges}</td>
                    <td>{item.serviceChargesPaid}</td>
                    <td>{item.extraAmountPaid}</td>
                    <td>{item.status === 0 ? "Pending" : "Paid"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <ReactPaginate
          breakLabel="..."
          nextLabel="Next >"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={Math.ceil(totalItems / itemsPerPage)}
          previousLabel="< Previous"
          renderOnZeroPageCount={null}
        />
      </div>
    </div>
  );
};

export default WeeklyChargesList;